var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, "label-width": "120px", width: "850px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      [
        _c(
          "BjDivider",
          {
            scopedSlots: _vm._u([
              {
                key: "right",
                fn: function () {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.allWarehouse },
                      },
                      [_vm._v(_vm._s(_vm.$t("allStockInText")))]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [_vm._v(_vm._s(_vm.$t("AddInternalRefundOnlyDoc.Product")) + " ")]
        ),
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              "row-class-name": _vm.tableRowClassName,
              data: _vm.form.goodsList,
              border: "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "purchaseCode",
                label: _vm.$t("BusinessPurchaseComponentsPur.code"),
                align: "center",
                width: "127",
              },
            }),
            _c("el-table-column", {
              attrs: { prop: "skuCode", label: "SKU", align: "center" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "planQty",
                label: _vm.$t("BusinessPurchaseEntryComPage.planQty"),
                align: "center",
                width: "129",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "waitQty",
                label: _vm.$t("BusinessPurchaseComponentsCom.waitQty"),
                align: "center",
                width: "100",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "alreadyQty",
                label: _vm.$t("BusinessPurchaseEntryComPage.alreadyQty"),
                width: "138",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("BjInputNumber", {
                        attrs: { clearable: "" },
                        model: {
                          value: row.alreadyQty,
                          callback: function ($$v) {
                            _vm.$set(row, "alreadyQty", $$v)
                          },
                          expression: "row.alreadyQty",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: _vm.$t("BusinessPurchaseOrderList.dataForm.tolerant"),
                prop: "dataFaultToleranceQty",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("BjInputNumber", {
                        attrs: { min: "0", clearable: "" },
                        model: {
                          value: row.dataFaultToleranceQty,
                          callback: function ($$v) {
                            _vm.$set(row, "dataFaultToleranceQty", $$v)
                          },
                          expression: "row.dataFaultToleranceQty",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }